module.exports = "https://coursera_assets.s3.amazonaws.com/images/e002639db4699401b5d6ca5926a2b0e3.jpg";